import { IExposableService } from '../../background/services/external-services-exposer.service';
import { PromotionDisplayDetails } from '../models/promotion-display-details.model';
import { TrackEvent } from '../../shared/models/tracking-event.model';

// -----------------------------------------------------------------------------
export const kNameOfUserActionService = 'UserActionService';

// -----------------------------------------------------------------------------
export interface IUserActionService extends IExposableService {
  sendTrackingEvent(event: TrackEvent);
  promotionDisplayed(promotionDisplayed: PromotionDisplayDetails);
  promotionDismissed(promotionDisplayed: PromotionDisplayDetails);
  promotionOfferApproved(promotionDisplayed: PromotionDisplayDetails);
  sendErrorTrackingEvent(promotionDismissed: PromotionDisplayDetails);
  OpenExternalUrl(url: string, activePromotionInfo: PromotionDisplayDetails);
  openNotificationSettings(activePromotionInfo: PromotionDisplayDetails);
  turnOffPromotions(activePromotionInfo: PromotionDisplayDetails);
}

export interface IUserActionServiceDelegate {
  onUserActionDisplayed?(activePromotion: PromotionDisplayDetails);
  onUserActionDismissed?(activePromotion: PromotionDisplayDetails);
  onUserActionApproved?(activePromotion: PromotionDisplayDetails);
  onUserActionCTAClicked?(activePromotion: PromotionDisplayDetails);
}
